// Colour and type come from the shared SupplyVue design system (src/design/);
// this module keeps only the Optimiser's own grid styling.
import { TOKENS, FONT_SANS, FONT_MONO } from 'Design/tokens'

export { TOKENS, FONT_SANS, FONT_MONO }

export const GRID_SX = {
  '& .MuiDataGrid-root': {
    border: 'none',
    fontFamily: FONT_SANS,
    color: TOKENS.ink900,
    '--DataGrid-rowBorderColor': TOKENS.line100,
    '& .MuiDataGrid-columnHeaders': {
      borderBottom: `1px solid ${TOKENS.line300}`,
    },
    '& .MuiDataGrid-columnHeader, & .MuiDataGrid-columnHeader--pinnedLeft': {
      backgroundColor: `${TOKENS.panelHead} !important`,
      color: `${TOKENS.ink400} !important`,
      borderRadius: 0,
    },
    '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within':
      { outline: 'none' },
    '& .MuiDataGrid-columnHeaderTitle': {
      fontFamily: FONT_SANS,
      fontSize: 10.5,
      fontWeight: 700,
      textTransform: 'uppercase',
      letterSpacing: '0.05em',
      color: TOKENS.ink400,
    },
    '& .MuiDataGrid-iconButtonContainer, & .MuiDataGrid-sortIcon, & .MuiDataGrid-menuIconButton':
      { color: TOKENS.ink400 },
    '& .MuiDataGrid-columnSeparator': { display: 'none' },
    '& .MuiDataGrid-cell': {
      fontFamily: FONT_SANS,
      fontSize: 12,
      color: TOKENS.ink900,
      '&:focus, &:focus-within': { outline: 'none' },
    },
    '& .MuiDataGrid-cell--withRightBorder, & .MuiDataGrid-columnHeader--withRightBorder':
      { borderRight: 'none' },
    '& .MuiDataGrid-row.row--odd, & .MuiDataGrid-row.row--odd .MuiDataGrid-cell':
      { backgroundColor: TOKENS.surface50 },
    '& .MuiDataGrid-row.row--even, & .MuiDataGrid-row.row--even .MuiDataGrid-cell':
      { backgroundColor: TOKENS.surface0 },
    '& .MuiDataGrid-row:hover, & .MuiDataGrid-row:hover .MuiDataGrid-cell': {
      backgroundColor: TOKENS.blue50,
    },
    '& .MuiDataGrid-footerContainer': {
      fontFamily: FONT_SANS,
      minHeight: 40,
      borderTop: `1px solid ${TOKENS.line200}`,
    },
    '& .MuiTablePagination-root, & .MuiTablePagination-root *': {
      fontFamily: FONT_SANS,
      fontSize: 12,
    },
    '& .sch-num': {
      fontFamily: FONT_MONO,
      fontVariantNumeric: 'tabular-nums',
      letterSpacing: '-0.02em',
      justifyContent: 'flex-end',
      textAlign: 'right',
    },
  },
}
